import apiUrl from '@/apis/api';
import { postWithAuth } from '@/lib/httpAdapter';

export interface BitbucketProject {
  key: string;
  name: string;
  description?: string;
}

export interface FetchBitbucketProjectsResponse {
  projects: BitbucketProject[];
  workspace?: string;
  error?: string;
}

/**
 * Fetches projects in the org's Bitbucket workspace. Used to populate the
 * project filter on the Code Management settings tab.
 */
export async function fetchBitbucketProjects(
  orgUUID: string,
  userUUID: string = ''
): Promise<FetchBitbucketProjectsResponse> {
  try {
    const res = await postWithAuth(
      `${apiUrl}fetchBitbucketProjects/`,
      { OrgUUID: orgUUID, UserUUID: userUUID },
      { credentials: 'include' }
    );
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const raw = await res.json();
    const json = (typeof raw === 'string' ? JSON.parse(raw) : raw) as Record<
      string,
      unknown
    >;
    const rows = Array.isArray(json.Projects) ? json.Projects : [];
    const projects: BitbucketProject[] = rows
      .map((p: Record<string, unknown>) => ({
        key: String(p.Key ?? '').trim(),
        name: String(p.Name ?? '').trim() || String(p.Key ?? '').trim(),
        description: p.Description ? String(p.Description) : undefined,
      }))
      .filter((p: BitbucketProject) => p.key.length > 0);
    return {
      projects,
      workspace: json.Workspace ? String(json.Workspace) : undefined,
      error: json.Error ? String(json.Error) : undefined,
    };
  } catch (err) {
    return {
      projects: [],
      error: err instanceof Error ? err.message : 'Unknown error',
    };
  }
}
